import type {
  ExternalLink as ExternalLinkType,
  InternalLink as InternalLinkType
} from 'types/capi/shared';

import useUser from '~/hooks/useUser';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import { getTrackedUrlAndClickRef } from '../../utils/tracking';
import Tracked from '../Tracked';

type Props = {
  preventPropagation?: boolean;
};

export const Internal = ({
  link,
  preventPropagation = false
}: { link: InternalLinkType } & Props) => {
  function handleClickInternalLink(e: React.SyntheticEvent) {
    if (preventPropagation) e.stopPropagation();
  }

  return (
    <Tracked.InternalLink
      className="inline font-semibold underline"
      variant="none"
      pagePosition="Body"
      name={link.text as TrackedButtonClickName}
      to={link.path}
      onClick={handleClickInternalLink}
    >
      {link.text}
    </Tracked.InternalLink>
  );
};

export const External = ({
  link,
  preventPropagation = false
}: { link: ExternalLinkType } & Props) => {
  const user = useUser();

  const { url } = getTrackedUrlAndClickRef(link, { user });

  return (
    <Tracked.ExternalLink
      href={url}
      variant="none"
      target="_blank"
      onClick={(e: React.SyntheticEvent) => {
        if (preventPropagation) e.stopPropagation();
      }}
      name={link.text as TrackedButtonClickName}
      rel="sponsored nofollow noopener"
      pagePosition="Body"
      className="inline font-semibold underline"
    >
      {link.text}
    </Tracked.ExternalLink>
  );
};

export default { External, Internal };
